// @ts-expect-error
import {COUNTRY_VALUES} from 'shells/select/country-select';

import type {BaseFormInfo, CardForm, BankForm, AddressForm} from './types';

export const cardValidationFields = [
    'first_name',
    'last_name',
    // These three fields are built in to the Recurly
    // CardElement, but the token will still give us
    // validation info
    'number',
    'month',
    'year',
    'cvv',
] as const;

export const bankValidationFields = [
    'routing_number',
    'account_number',
    'account_number_confirmation',
    'account_type',
    'name_on_account',
] as const;

export const addressValidationFields = [
    'phone',
    'address1',
    'city',
    'state',
    'country',
    'postal_code',
] as const;

export const formValidationFields = ['email', 'companyName', 'agree'] as const;

export const defaultCardForm: CardForm = {
    first_name: '',
    last_name: '',
    number: '',
    month: '',
    year: '',
    cvv: '',
};

export const defaultBankForm: BankForm = {
    routing_number: '',
    account_number: '',
    account_number_confirmation: '',
    account_type: '',
    name_on_account: '',
};

export const defaultAddressForm: AddressForm = {
    phone: '',
    address1: '',
    address2: '',
    city: '',
    state: '',
    postal_code: '',
    country: '',
};

export const defaultBaseFormInfo: BaseFormInfo = {
    paymentType: 'card',
    email: '',
    companyName: '',
    agree: true,
};

// @ts-expect-error
export const COUNTRIES = COUNTRY_VALUES.map((country) => ({
    value: country.id,
    label: country.name,
}));
